import React, { useEffect, useMemo, useState } from 'react';
import styles from './ConfirmDialog.module.less';
import TextureNoise from '@/assets/logo.png';
import closeIcon from '@/assets/project/closewhite.png';
import { infoController } from '@/api';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';

const ConfirmDialog = (props) => {
  return (
    <div className={styles.page}>
      <div className={styles.popContent}>
        <div className={styles.icon}></div>
        <div className={styles.content}>{props.content}</div>
        <div className={styles.buttons}>
          <div
            className={styles.cancelButton}
            onClick={() => {
              props?.onCancel();
            }}>
            {props.cancelTitle || 'Cancel'}
          </div>
          <div
            className={styles.confirmButton}
            onClick={() => {
              props?.onConfirm();
            }}>
            {props.confirmTitle || 'Confirm'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
